/* Resources */
/* Components */
import Header from "../components/common/Header";
import Icon from "../components/common/Icon";


export default function Missing() {
    const sources = "fa fa-exclamation-triangle";

    return (
        <main>
            <Header location="Page introuvable" parent="" />
            <div className="content-wrapper flex">
                <div className="background">
                    <i className={sources}></i>
                </div>
                <section className="static-page">
                    <div className="dashboard">
                        <Icon source={ sources } color="blue missing" span="La page demandée n'existe pas."/>
                    </div>
                </section>
            </div>
        </main>
    )
}